module.exports = __webpack_public_path__ + "img/title.19c7cb99.png";